function _regeneratorValues(e) {
  if (null != e) {
    var t = e["function" == typeof Symbol && Symbol.iterator || "@@iterator"],
      r = 0;
    if (t) return t.call(e);
    if ("function" == typeof e.next) return e;
    if (!isNaN(e.length)) return {
      next: function next() {
        return e && r >= e.length && (e = void 0), {
          value: e && e[r++],
          done: !e
        };
      }
    };
  }
  throw new TypeError(_typeof(e) + " is not iterable");
}
function _regeneratorKeys(e) {
  var n = Object(e),
    r = [];
  for (var t in n) r.unshift(t);
  return function e() {
    for (; r.length;) if ((t = r.pop()) in n) return e.value = t, e.done = !1, e;
    return e.done = !0, e;
  };
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
function _superPropGet(t, o, e, r) {
  var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e);
  return 2 & r && "function" == typeof p ? function (t) {
    return p.apply(e, t);
  } : p;
}
function _get() {
  return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
    var p = _superPropBase(e, t);
    if (p) {
      var n = Object.getOwnPropertyDescriptor(p, t);
      return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
    }
  }, _get.apply(null, arguments);
}
function _superPropBase(t, o) {
  for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t)););
  return t;
}
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
var ModTemplate = require('../../lib/templates/modtemplate');
var saito = require('../../lib/saito/saito');
var JsStore = require('jsstore');
var JSON = require('json-bigint');
var Transaction = require('../../lib/saito/transaction')["default"];
var PeerService = require('saito-js/lib/peer_service')["default"];
var ArchiveTemplate = require('./lib/archive.template');
var ArchiveSummary = require('./lib/archive-summary.template');
var ArchiveSettings = require('./lib/archive-settings');
var SaitoOverlay = require('../../lib/saito/ui/saito-overlay/saito-overlay');
var jsonTree = require('json-tree-viewer');
function archiveLogBindParams(params) {
  var out = {};
  if (!params || _typeof(params) !== 'object') {
    return params;
  }
  for (var _i = 0, _Object$keys = Object.keys(params); _i < _Object$keys.length; _i++) {
    var k = _Object$keys[_i];
    if (k === '$tx' || k === 'tx') {
      var v = params[k];
      out[k] = '<omitted tx blob, length ' + (v == null ? 0 : String(v).length) + '>';
    } else {
      out[k] = params[k];
    }
  }
  return out;
}

//
// HOW THE ARCHIVE SAVES TXS
//
// modules call ---> app.storage.saveTransaction()
//    ---> saveTransaction() sends TX to peers via "archive" request="save" transaction
//    ---> peers receive by handlePeerTransaction();
//    ---> peers save to DB
//
// HOW THE ARCHIVE LOADS TXS
//
// modules call ---> app.storage.loadTransactions()
//    ---> loadTransactions() sends TX to peers via "archive" request="save" transaction
//    ---> peers receive by handlePeerTransaction();
//    ---> peers fetch from DB, return via callback or return TX
//
var Archive = /*#__PURE__*/function (_ModTemplate) {
  function Archive(app) {
    var _this;
    _classCallCheck(this, Archive);
    _this = _callSuper(this, Archive, [app]);
    _this.name = 'Archive';
    _this.slug = 'archive';
    _this.description = 'Supports the saving and serving of network transactions';
    _this.categories = 'Utilities Core';
    _this["class"] = 'utility';
    _this.status = 'prod';
    _this.localDB = null;
    _this.opt_out = ['Chat', 'RedSquare', 'Blog']; // Modules that handle their own automated storage

    //
    // if this is set to 1, this archive node will respect ownership
    // specifications provided in the form of access_hash scripts. an
    // example of an application that needs this is the Vault, which
    // manually sets it on init.
    //
    // any read / write / delete requests must pass the access hash
    //
    // if access_hash is 0, the archive node will return all content
    // on request like a normal archive node, not respect ownership
    // limitations like a private archive node that wants to limit
    // usage of privately-uploaded data.
    //
    //this.enforce_access_hash = 0; // ignore access_hash
    _this.enforce_access_hash = 1; // don't serve txs with access_hash restrictions

    _this.schema = ['id', 'user_id', 'publickey', 'owner', 'sig', 'field1', 'field2', 'field3', 'field4', 'field5', 'block_id', 'block_hash', 'created_at', 'updated_at', 'tx', 'tx_size', 'flagged', 'preserve'];
    //
    //
    //
    _this.prune_public_ts = 21 * 24 * 60 * 60 * 1000;
    _this.prune_private_ts = 450000000; // about 5 days

    //
    // settings saved and loaded from app.options
    //
    _this.archive = {
      index_blockchain: 0,
      last_prune: 0
    };
    if (_this.app.BROWSER == 0) {
      _this.archive.index_blockchain = 1;
    } else {
      _this.localDB = new JsStore.Connection(new Worker('/saito/lib/jsstore/jsstore.worker.js'));
    }
    return _this;
  }
  _inherits(Archive, _ModTemplate);
  return _createClass(Archive, [{
    key: "initialize",
    value: function () {
      var _initialize = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(app) {
        var _this$archive2,
          _this2 = this;
        var _this$archive, wv, path, fs, data_dir, now;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return _superPropGet(Archive, "initialize", this, 3)([app]);
            case 1:
              this.load();
              if (!app.BROWSER) {
                _context.n = 5;
                break;
              }
              _context.n = 2;
              return this.initInBrowserDatabase();
            case 2:
              if (!((_this$archive = this.archive) !== null && _this$archive !== void 0 && _this$archive.wallet_version)) {
                _context.n = 4;
                break;
              }
              wv = this.archive.wallet_version;
              try {
                wv = parseFloat(wv);
              } catch (err) {
                console.error(err);
                wv = 0;
              }
              if (!(wv <= 5.555)) {
                _context.n = 4;
                break;
              }
              console.warn('PURGING LOCAL DB ', wv);
              _context.n = 3;
              return this.localDB.dropDb();
            case 3:
              _context.n = 4;
              return this.initInBrowserDatabase();
            case 4:
              _context.n = 6;
              break;
            case 5:
              path = this.app.storage.returnPath();
              fs = this.app.storage.returnFileSystem();
              if (fs && path) {
                data_dir = "".concat(__dirname, "/../../data/archive");
                if (!fs.existsSync(path.normalize(data_dir))) {
                  fs.mkdirSync(data_dir);
                  console.info('Created directory for archive to store large transactions');
                }
              }
            case 6:
              now = new Date().getTime(); //
              // Don't prune more than once a day, but otherwise on connection/spin up
              //
              if (!((_this$archive2 = this.archive) !== null && _this$archive2 !== void 0 && _this$archive2.last_prune) || this.archive.last_prune + 24 * 60 * 60 * 1000 < now) {
                this.pruneArchive();
              }
              setInterval(function () {
                _this2.pruneArchive();
              }, 24 * 60 * 60 * 1000 + 5000);
            case 7:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function initialize(_x) {
        return _initialize.apply(this, arguments);
      }
      return initialize;
    }()
  }, {
    key: "initInBrowserDatabase",
    value: function () {
      var _initInBrowserDatabase = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var archives, db, isDbCreated;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              if (this.app.BROWSER) {
                _context2.n = 1;
                break;
              }
              return _context2.a(2);
            case 1:
              //
              // Create Local DB schema
              //
              archives = {
                name: 'archives',
                columns: {
                  id: {
                    primaryKey: true,
                    autoIncrement: true
                  },
                  user_id: {
                    dataType: 'number',
                    "default": 0
                  },
                  publicKey: {
                    dataType: 'string',
                    "default": ''
                  },
                  owner: {
                    dataType: 'string',
                    "default": ''
                  },
                  sig: {
                    dataType: 'string',
                    "default": ''
                  },
                  field1: {
                    dataType: 'string',
                    "default": ''
                  },
                  field2: {
                    dataType: 'string',
                    "default": ''
                  },
                  field3: {
                    dataType: 'string',
                    "default": ''
                  },
                  field4: {
                    dataType: 'string',
                    "default": ''
                  },
                  field5: {
                    dataType: 'string',
                    "default": ''
                  },
                  block_id: {
                    dataType: 'number',
                    "default": 0
                  },
                  block_hash: {
                    dataType: 'string',
                    "default": ''
                  },
                  created_at: {
                    dataType: 'number',
                    "default": 0
                  },
                  updated_at: {
                    dataType: 'number',
                    "default": 0
                  },
                  tx: {
                    dataType: 'string',
                    "default": ''
                  },
                  tx_size: {
                    dataType: 'number',
                    "default": ''
                  },
                  flagged: {
                    dataType: 'number',
                    "default": 0
                  },
                  preserve: {
                    dataType: 'number',
                    "default": 0
                  }
                }
              };
              /*
              Ideally one, of the 5 arbitrary fields should be number with an ability to search above/below...
              without changing the db schemas, we will designate field5 as a string coded number 
              (since no apps are using it yet) and pending further flexibility treat its inclusion as a >= search tag
              */
              db = {
                name: 'archive_db',
                tables: [archives]
              };
              _context2.n = 2;
              return this.localDB.initDb(db);
            case 2:
              isDbCreated = _context2.v;
            case 3:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function initInBrowserDatabase() {
        return _initInBrowserDatabase.apply(this, arguments);
      }
      return initInBrowserDatabase;
    }()
  }, {
    key: "render",
    value: function () {
      var _render = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var ct, mem, ts, cHook, sHook, cont, rows, _iterator, _step, row;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              ct = 0;
              mem = 0;
              ts = Date.now();
              this.app.browser.prependElementToDom(ArchiveSummary(this.app));
              this.app.browser.replaceElementBySelector("<div class=\"local-archive-table\"></div>", '.main');
              this.app.browser.addElementToSelector(ArchiveTemplate(this.app, null), '.local-archive-table');
              cHook = document.getElementById('tx-ct');
              sHook = document.getElementById('db-size');
              cont = true;
            case 1:
              if (!cont) {
                _context3.n = 3;
                break;
              }
              _context3.n = 2;
              return this.loadTransactions({
                updated_earlier_than: ts
              });
            case 2:
              rows = _context3.v;
              /*let rows = await this.localDB.select({
              from: 'archives',
              order: { by: 'id', type: 'desc' }
              });*/
              _iterator = _createForOfIteratorHelper(rows);
              try {
                for (_iterator.s(); !(_step = _iterator.n()).done;) {
                  row = _step.value;
                  this.app.browser.addElementToSelector(ArchiveTemplate(this.app, row), '.local-archive-table');
                  mem += row.tx_size;
                  ts = Math.min(ts, row.updated_at);
                }
              } catch (err) {
                _iterator.e(err);
              } finally {
                _iterator.f();
              }
              ct += rows.length;
              cHook.innerHTML = ct;
              sHook.innerHTML = mem;

              //0 rows returned ==> done!
              cont = rows.length;
              _context3.n = 1;
              break;
            case 3:
              siteMessage('Achive fully loaded!');
              this.attachEvents();
            case 4:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function render() {
        return _render.apply(this, arguments);
      }
      return render;
    }()
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _this3 = this;
      document.querySelectorAll('.archive-button').forEach(function (tx_handle) {
        tx_handle.onclick = function (e) {
          var tx_json = e.currentTarget.dataset.tx;
          var tx = new Transaction();
          tx.deserialize_from_web(_this3.app, tx_json);
          var overlay = new SaitoOverlay(_this3.app, _this3);
          overlay.show("<div class=\"tx_overlay\"></div>");
          var txmsg = tx.returnMessage();

          //debug info
          var el = document.querySelector('.tx_overlay');
          var tree = jsonTree.create(txmsg, el);
          tree.expand(function (node) {
            return node.label !== 'images';
          });
          if (tx !== null && tx !== void 0 && tx.optional) {
            var tree2 = jsonTree.create(tx.optional, el);
            tree2.expand();
          }
        };
      });
      document.querySelectorAll('.delete-me').forEach(function (btn) {
        btn.onclick = /*#__PURE__*/function () {
          var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(e) {
            var sig, row, res;
            return _regenerator().w(function (_context4) {
              while (1) switch (_context4.n) {
                case 0:
                  sig = e.currentTarget.dataset.id;
                  row = e.currentTarget.parentElement;
                  e.currentTarget.onclick = null;
                  _context4.n = 1;
                  return _this3.deleteTransaction(sig);
                case 1:
                  res = _context4.v;
                  if (res) {
                    row.remove();
                  }
                case 2:
                  return _context4.a(2);
              }
            }, _callee4);
          }));
          return function (_x2) {
            return _ref.apply(this, arguments);
          };
        }();
      });
    }
  }, {
    key: "returnServices",
    value: function returnServices() {
      var services = [];
      if (this.app.BROWSER == 0) {
        services.push(new PeerService(null, 'archive'));
      }
      return services;
    }

    //
    // by default we just save everything that is an application
    //
  }, {
    key: "onConfirmation",
    value: function () {
      var _onConfirmation = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(blk, tx, conf) {
        var _this4 = this;
        var block_id, block_hash, txmsg, obj;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              if (!(this.app.BROWSER && !tx.isTo(this.publicKey))) {
                _context6.n = 1;
                break;
              }
              return _context6.a(2);
            case 1:
              if (!(Number(conf) == 0 && this.archive.index_blockchain == 1)) {
                _context6.n = 3;
                break;
              }
              block_id = Number(blk.id || 0);
              block_hash = (blk === null || blk === void 0 ? void 0 : blk.hash) || ''; // Use the storage function for standard formatting
              txmsg = tx.returnMessage();
              if (!((txmsg === null || txmsg === void 0 ? void 0 : txmsg.module) == 'spam')) {
                _context6.n = 2;
                break;
              }
              return _context6.a(2);
            case 2:
              obj = {
                block_id: block_id,
                block_hash: block_hash
              };
              if (tx.type == 8) {
                obj.field4 = this.app.wallet.computeNFTIdFromTx(tx);
                obj.field1 = txmsg.module || 'NFT';
                obj.preserve = 1;
              }
              setTimeout(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
                var txs;
                return _regenerator().w(function (_context5) {
                  while (1) switch (_context5.n) {
                    case 0:
                      _context5.n = 1;
                      return _this4.loadTransactions({
                        signature: tx.signature
                      });
                    case 1:
                      txs = _context5.v;
                      if ((txs === null || txs === void 0 ? void 0 : txs.length) > 0) {
                        _this4.updateTransaction(tx, obj);
                      } else {
                        _this4.app.storage.saveTransaction(tx, obj, 'localhost');
                      }
                    case 2:
                      return _context5.a(2);
                  }
                }, _callee5);
              })), 10000);
            case 3:
              return _context6.a(2);
          }
        }, _callee6, this);
      }));
      function onConfirmation(_x3, _x4, _x5) {
        return _onConfirmation.apply(this, arguments);
      }
      return onConfirmation;
    }()
  }, {
    key: "handlePeerTransaction",
    value: function () {
      var _handlePeerTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7(app) {
        var tx,
          peer,
          mycallback,
          req,
          ts1,
          txs,
          newtx,
          _args7 = arguments;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.n) {
            case 0:
              tx = _args7.length > 1 && _args7[1] !== undefined ? _args7[1] : null;
              peer = _args7.length > 2 ? _args7[2] : undefined;
              mycallback = _args7.length > 3 ? _args7[3] : undefined;
              if (!(tx == null)) {
                _context7.n = 1;
                break;
              }
              return _context7.a(2, 0);
            case 1:
              req = tx.returnMessage();
              if (!(!(req !== null && req !== void 0 && req.request) || !(req !== null && req !== void 0 && req.data))) {
                _context7.n = 2;
                break;
              }
              return _context7.a(2, 0);
            case 2:
              if (!(req.request === 'archive')) {
                _context7.n = 9;
                break;
              }
              if (!(req.data.request === 'load')) {
                _context7.n = 4;
                break;
              }
              ts1 = Date.now(); //
              // add REQUESTER and TS to submitted object
              //
              // over-write any existing information / vars in order to
              // avoid users submitting with correct information inappropriately
              //
              if (req.data) {
                if (_typeof(req.data) === 'object' && req.data !== null && !Array.isArray(req.data)) {
                  if (peer && peer.publicKey) {
                    req.data.REQUESTER = peer.publicKey;
                    req.data.NOW = new Date().getTime();
                  } else {
                    req.data.REQUESTER = '';
                    req.data.NOW = new Date().getTime();
                  }
                }
              }

              //
              //Duplicates loadTransactionsWithCallback, but that's fine
              //
              _context7.n = 3;
              return this.loadTransactions(req.data);
            case 3:
              txs = _context7.v;
              if (!mycallback) {
                _context7.n = 4;
                break;
              }
              mycallback(txs);
              return _context7.a(2, 1);
            case 4:
              newtx = new Transaction();
              newtx.deserialize_from_web(app, req.data.serial_transaction);
              if (!(req.data.request === 'delete')) {
                _context7.n = 5;
                break;
              }
              _context7.n = 5;
              return this.deleteTransaction(newtx, req.data);
            case 5:
              if (!(req.data.request === 'multidelete')) {
                _context7.n = 6;
                break;
              }
              _context7.n = 6;
              return this.deleteTransactions(req.data);
            case 6:
              if (!(req.data.request === 'save')) {
                _context7.n = 7;
                break;
              }
              _context7.n = 7;
              return this.saveTransaction(newtx, req.data);
            case 7:
              if (!(req.data.request === 'update')) {
                _context7.n = 8;
                break;
              }
              _context7.n = 8;
              return this.updateTransaction(newtx, req.data);
            case 8:
              return _context7.a(2, 0);
            case 9:
              return _context7.a(2, _superPropGet(Archive, "handlePeerTransaction", this, 3)([app, tx, peer, mycallback]));
          }
        }, _callee7, this);
      }));
      function handlePeerTransaction(_x6) {
        return _handlePeerTransaction.apply(this, arguments);
      }
      return handlePeerTransaction;
    }() //////////
    // save //
    //////////
  }, {
    key: "saveTransaction",
    value: function () {
      var _saveTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8(tx) {
        var obj,
          newObj,
          numRows,
          sql,
          params,
          _this$app,
          fs,
          filename,
          _args8 = arguments;
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.n) {
            case 0:
              obj = _args8.length > 1 && _args8[1] !== undefined ? _args8[1] : {};
              newObj = {}; //
              // User_id should be the ID of the User table... for library ownership???
              //
              newObj.user_id = (obj === null || obj === void 0 ? void 0 : obj.user_id) || 0; //What is this supposed to be

              newObj.publicKey = (obj === null || obj === void 0 ? void 0 : obj.publicKey) || tx.from[0].publicKey;
              newObj.owner = (obj === null || obj === void 0 ? void 0 : obj.owner) || '';
              newObj.sig = (obj === null || obj === void 0 ? void 0 : obj.signature) || tx.signature || (obj === null || obj === void 0 ? void 0 : obj.sig);
              //Field1-3 are set by default in app.storage
              newObj.field1 = (obj === null || obj === void 0 ? void 0 : obj.field1) || '';
              newObj.field2 = (obj === null || obj === void 0 ? void 0 : obj.field2) || '';
              newObj.field3 = (obj === null || obj === void 0 ? void 0 : obj.field3) || '';
              newObj.field4 = (obj === null || obj === void 0 ? void 0 : obj.field4) || '';
              newObj.field5 = (obj === null || obj === void 0 ? void 0 : obj.field5) || '';
              newObj.block_id = (obj === null || obj === void 0 ? void 0 : obj.block_id) || 0;
              newObj.block_hash = (obj === null || obj === void 0 ? void 0 : obj.block_hash) || '';
              newObj.flagged = 0;
              newObj.preserve = (obj === null || obj === void 0 ? void 0 : obj.preserve) || 0;
              newObj.created_at = (obj === null || obj === void 0 ? void 0 : obj.created_at) || tx.timestamp;
              newObj.updated_at = (obj === null || obj === void 0 ? void 0 : obj.updated_at) || tx.timestamp;

              // For consistency, also need to store this on saveTransaction
              if (!tx.optional) {
                tx.optional = {};
              }
              tx.optional.updated_at = newObj.updated_at;
              newObj.tx = tx.serialize_to_web(this.app);
              newObj.tx_size = newObj.tx.length;
              if (!this.app.BROWSER) {
                _context8.n = 2;
                break;
              }
              _context8.n = 1;
              return this.localDB.insert({
                into: 'archives',
                values: [newObj]
              });
            case 1:
              numRows = _context8.v;
              if (numRows) {
                console.debug('Local Archive index successfully inserted.');
                //					'Local Archive index successfully inserted: ',
                //					JSON.parse(JSON.stringify(newObj))
                //				);
              } else {
                console.debug('Local Archive index not inserted...');
              }
              _context8.n = 3;
              break;
            case 2:
              //
              // insert index record
              //
              sql = "INSERT\n                  OR IGNORE INTO archives (\n                    publickey, \n                    owner, \n                    sig, \n                    field1, \n                    field2, \n                    field3, \n                    field4, \n                    field5, \n                    block_id, \n                    block_hash, \n                    created_at, \n                    updated_at, \n                    tx,\n                    tx_size,\n                    flagged,\n                    preserve\n                  ) VALUES (\n                  $publickey,\n                  $owner,\n                  $sig,\n                  $field1,\n                  $field2,\n                  $field3,\n                  $field4,\n                  $field5,\n                  $block_id,\n                  $block_hash,\n                  $created_at,\n                  $updated_at,\n                  $tx,\n                  $tx_size,\n                  $flagged,\n                  $preserve\n                  )";
              params = {
                $publickey: newObj.publicKey,
                $owner: newObj.owner,
                $sig: newObj.sig,
                $field1: newObj.field1,
                $field2: newObj.field2,
                $field3: newObj.field3,
                $field4: newObj.field4,
                $field5: newObj.field5,
                $block_id: newObj.block_id,
                $block_hash: newObj.block_hash,
                $created_at: newObj.created_at,
                $updated_at: newObj.updated_at,
                $tx: newObj.tx,
                $tx_size: newObj.tx_size,
                $flagged: newObj.flagged,
                $preserve: newObj.preserve
              };
              if (newObj.tx_size > 50000) {
                fs = (_this$app = this.app) === null || _this$app === void 0 || (_this$app = _this$app.storage) === null || _this$app === void 0 ? void 0 : _this$app.returnFileSystem();
                if (fs) {
                  filename = "".concat(__dirname, "/../../data/archive/").concat(newObj.sig);
                  fs.writeFileSync(filename, newObj.tx);
                  params['$tx'] = '';
                }
              }
              _context8.n = 3;
              return this.app.storage.runDatabase(sql, params, 'archive');
            case 3:
              return _context8.a(2);
          }
        }, _callee8, this);
      }));
      function saveTransaction(_x7) {
        return _saveTransaction.apply(this, arguments);
      }
      return saveTransaction;
    }() /////////////////////////////////////////////////////
    // update  -- we can update any arbitrary set of the fields (though we usually just update the tx itself)
    /////////////////////////////////////////////////////
  }, {
    key: "updateTransaction",
    value: function () {
      var _updateTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9(tx) {
        var obj,
          newObj,
          context,
          tx_to_update,
          select_sql,
          select_params,
          existing_rows,
          set_clauses,
          params,
          key,
          existing_row,
          can_update,
          request_tx,
          sql,
          _this$app2,
          fs,
          filename,
          _args9 = arguments,
          _t,
          _t2;
        return _regenerator().w(function (_context9) {
          while (1) switch (_context9.n) {
            case 0:
              obj = _args9.length > 1 && _args9[1] !== undefined ? _args9[1] : {};
              //
              // update records
              //
              newObj = {};
              context = {};
              context.db = {};
              context.db.type = "UPDATE";

              //
              // Row identity (archives.sig) is immutable via this function.
              // obj.sig / obj.signature are LOOKUP keys only (WHERE sig = ...).
              // They must never appear in the SET clause, even though `sig` is in this.schema.
              //
              // tx == null  → identity must come from obj.sig (or obj.signature)
              // tx != null  → preserve prior resolution order: obj.signature || obj.sig || tx.signature
              //
              tx_to_update = tx ? (obj === null || obj === void 0 ? void 0 : obj.signature) || (obj === null || obj === void 0 ? void 0 : obj.sig) || (tx === null || tx === void 0 ? void 0 : tx.signature) || '' : (obj === null || obj === void 0 ? void 0 : obj.sig) || (obj === null || obj === void 0 ? void 0 : obj.signature) || ''; // fallback in case we didn't provide a timestamp (though should be handled by storage.ts)
              if (!obj.updated_at) {
                obj.updated_at = new Date().getTime();
              }

              //
              // When tx is provided, rewrite archives.tx / tx_size from that transaction.
              // When tx is null, leave the stored archives.tx blob unchanged and update
              // metadata only (e.g. owner), using obj.sig as the row lookup key.
              //
              if (tx) {
                if (!tx.optional) {
                  tx.optional = {};
                }
                tx.optional.updated_at = obj.updated_at;
                newObj.tx = tx.serialize_to_web(this.app);
                newObj.tx_size = newObj.tx.length;
              }
              if (tx_to_update) {
                _context9.n = 1;
                break;
              }
              return _context9.a(2, 0);
            case 1:
              //
              // AUTHORIZATION: same access-script gate as deleteTransaction()
              //
              select_sql = "SELECT sig, owner FROM archives WHERE archives.sig = $sig";
              select_params = {
                $sig: tx_to_update
              };
              _context9.n = 2;
              return this.app.storage.queryDatabase(select_sql, select_params, 'archive');
            case 2:
              existing_rows = _context9.v;
              if (!(this.app.BROWSER && (!existing_rows || existing_rows.length === 0))) {
                _context9.n = 4;
                break;
              }
              _context9.n = 3;
              return this.localDB.select({
                from: 'archives',
                where: {
                  sig: tx_to_update
                },
                limit: 1
              });
            case 3:
              existing_rows = _context9.v;
            case 4:
              //
              // update index — build SET clause without always rewriting tx
              //
              set_clauses = []; // $sig is bound ONLY for WHERE sig = $sig — never for SET sig = ...
              params = {
                $sig: tx_to_update
              };
              if (tx) {
                set_clauses.push('tx = $tx');
                set_clauses.push('tx_size = $tx_size');
                params.$tx = newObj.tx;
                params.$tx_size = newObj.tx_size;
              }

              //
              // Metadata fields from obj.
              // Explicitly exclude sig/signature even though `sig` is in this.schema —
              // callers must not be able to relocate an Archive row to a different signature.
              //
              _t = _regeneratorKeys(obj);
            case 5:
              if ((_t2 = _t()).done) {
                _context9.n = 7;
                break;
              }
              key = _t2.value;
              if (!(key === 'tx' || key === 'sig' || key === 'signature')) {
                _context9.n = 6;
                break;
              }
              return _context9.a(3, 5);
            case 6:
              if (this.schema.includes(key)) {
                set_clauses.push("".concat(key, " = $").concat(key));
                params["$".concat(key)] = obj[key];
                newObj[key] = obj[key];
                context.db[key] = obj[key];
              }
              _context9.n = 5;
              break;
            case 7:
              // Defense: browser JsStore set must never rewrite row identity.
              delete newObj.sig;
              delete newObj.signature;
              if (!(set_clauses.length === 0)) {
                _context9.n = 8;
                break;
              }
              return _context9.a(2, 0);
            case 8:
              if (!(existing_rows && existing_rows.length > 0)) {
                _context9.n = 12;
                break;
              }
              existing_row = existing_rows[0];
              if (!(existing_row.owner && existing_row.owner !== '')) {
                _context9.n = 12;
                break;
              }
              if (obj.access_script) {
                _context9.n = 9;
                break;
              }
              return _context9.a(2, 0);
            case 9:
              can_update = false;
              request_tx = obj.request_tx || tx || null;
              if (!(this.app.core.scripting.hash(obj.access_script) === existing_row.owner)) {
                _context9.n = 11;
                break;
              }
              _context9.n = 10;
              return this.app.core.scripting.evaluateWithTransaction(obj.access_script, request_tx, context);
            case 10:
              if (!_context9.v) {
                _context9.n = 11;
                break;
              }
              can_update = true;
            case 11:
              if (can_update) {
                _context9.n = 12;
                break;
              }
              return _context9.a(2, 0);
            case 12:
              sql = "UPDATE archives SET ".concat(set_clauses.join(', '), " WHERE sig = $sig");
              if (!this.app.BROWSER) {
                _context9.n = 14;
                break;
              }
              _context9.n = 13;
              return this.localDB.update({
                "in": 'archives',
                set: newObj,
                where: {
                  sig: tx_to_update
                }
              });
            case 13:
              _context9.n = 15;
              break;
            case 14:
              if (tx && newObj.tx_size > 50000) {
                fs = (_this$app2 = this.app) === null || _this$app2 === void 0 || (_this$app2 = _this$app2.storage) === null || _this$app2 === void 0 ? void 0 : _this$app2.returnFileSystem();
                if (fs) {
                  filename = "".concat(__dirname, "/../../data/archive/").concat(tx_to_update);
                  fs.writeFileSync(filename, newObj.tx);
                  params['$tx'] = '';
                }
              }
              _context9.n = 15;
              return this.app.storage.runDatabase(sql, params, 'archive');
            case 15:
              return _context9.a(2, 1);
          }
        }, _callee9, this);
      }));
      function updateTransaction(_x8) {
        return _updateTransaction.apply(this, arguments);
      }
      return updateTransaction;
    }() //////////
    // load //
    //////////
  }, {
    key: "loadTransactionsWithCallback",
    value: function () {
      var _loadTransactionsWithCallback = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0() {
        var obj,
          callback,
          txs,
          _args0 = arguments;
        return _regenerator().w(function (_context0) {
          while (1) switch (_context0.n) {
            case 0:
              obj = _args0.length > 0 && _args0[0] !== undefined ? _args0[0] : {};
              callback = _args0.length > 1 && _args0[1] !== undefined ? _args0[1] : null;
              _context0.n = 1;
              return this.loadTransactions(obj);
            case 1:
              txs = _context0.v;
              if (!callback) {
                _context0.n = 2;
                break;
              }
              return _context0.a(2, callback(txs));
            case 2:
              return _context0.a(2, txs);
            case 3:
              return _context0.a(2);
          }
        }, _callee0, this);
      }));
      function loadTransactionsWithCallback() {
        return _loadTransactionsWithCallback.apply(this, arguments);
      }
      return loadTransactionsWithCallback;
    }()
  }, {
    key: "loadTransactions",
    value: function () {
      var _loadTransactions = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee1() {
        var _rows,
          _this5 = this;
        var obj,
          limit,
          timestamp_limiting_clause,
          order_clause,
          sort,
          request_tx,
          order_obj,
          where_obj,
          param_count,
          params,
          sql,
          key,
          vault_access_read,
          ts,
          rows,
          _this$app3,
          fs,
          _iterator2,
          _step2,
          r,
          filename,
          time_elapsed,
          row_summaries,
          altered_rows,
          _iterator3,
          _step3,
          _loop,
          _args10 = arguments,
          _t3;
        return _regenerator().w(function (_context10) {
          while (1) switch (_context10.p = _context10.n) {
            case 0:
              obj = _args10.length > 0 && _args10[0] !== undefined ? _args10[0] : {};
              limit = 10;
              timestamp_limiting_clause = '';
              order_clause = ' ORDER BY archives.id';
              sort = 'DESC';
              request_tx = obj.request_tx || null; //For JS-Store
              order_obj = {
                by: 'id',
                type: 'desc'
              };
              where_obj = {};
              if (obj.created_later_than || obj.hasOwnProperty('created_later_than')) {
                timestamp_limiting_clause += ' AND created_at > ' + parseInt(obj.created_later_than);
                where_obj = {
                  created_at: {
                    '>': parseInt(obj.created_later_than)
                  }
                };
                order_clause = ' ORDER BY archives.created_at';
                order_obj.by = 'created_at';
              }
              if (obj.created_earlier_than || obj.hasOwnProperty('created_earlier_than')) {
                timestamp_limiting_clause += ' AND created_at < ' + parseInt(obj.created_earlier_than);
                where_obj = {
                  created_at: {
                    '<': parseInt(obj.created_earlier_than)
                  }
                };
                order_clause = ' ORDER BY archives.created_at';
                order_obj.by = 'created_at';
              }
              if (obj.tx_size_greater_than) {
                timestamp_limiting_clause += ' AND tx_size > ' + parseInt(obj.tx_size_greater_than);
                where_obj = {
                  tx_size: {
                    '>': parseInt(obj.tx_size_greater_than)
                  }
                };
              }
              if (obj.tx_size_less_than) {
                timestamp_limiting_clause += ' AND tx_size < ' + parseInt(obj.tx_size_less_than);
                where_obj = {
                  tx_size: {
                    '<': parseInt(obj.tx_size_less_than)
                  }
                };
              }
              if (obj.updated_later_than || obj.hasOwnProperty('updated_later_than')) {
                timestamp_limiting_clause += ' AND updated_at > ' + parseInt(obj.updated_later_than);
                where_obj = {
                  updated_at: {
                    '>': parseInt(obj.updated_later_than)
                  }
                };
                order_clause = ' ORDER BY archives.updated_at';
                order_obj.by = 'updated_at';
              }
              if (obj.updated_earlier_than || obj.hasOwnProperty('updated_earlier_than')) {
                timestamp_limiting_clause += ' AND updated_at < ' + parseInt(obj.updated_earlier_than);
                where_obj = {
                  updated_at: {
                    '<': parseInt(obj.updated_earlier_than)
                  }
                };
                order_clause = ' ORDER BY archives.updated_at';
                order_obj.by = 'updated_at';
              }
              if (obj.flagged) {
                timestamp_limiting_clause += ' AND flagged = ' + parseInt(obj.flagged);
                where_obj['flagged'] = {
                  '=': parseInt(obj.flagged)
                };
              }
              if (obj.flagged_ne != null || Object.prototype.hasOwnProperty.call(obj, 'flagged_ne')) {
                timestamp_limiting_clause += ' AND flagged != ' + parseInt(obj.flagged_ne);
                where_obj['flagged'] = {
                  '!=': parseInt(obj.flagged_ne)
                };
                delete obj.flagged_ne;
              }
              if (obj.ascending || obj.hasOwnProperty('ascending')) {
                sort = 'ASC';
                order_obj.type = 'asc';
              }

              //
              // ACCEPT REASONABLE LIMITS -- [10, 100]
              //
              if (obj.limit) {
                limit = Math.max(limit, obj.limit);
                limit = Math.min(limit, 100);
                delete obj.limit;
              }
              if (obj.signature) {
                obj.sig = obj.signature;
                delete obj.signature;
              }
              param_count = 0;
              params = {
                $limit: limit
              }; ///////////////////////////////////////////////////////////////////
              // Try getting everything for convenience, but monitor performance
              // Orig: tx, sig, updated_at, owner
              //////////////////////////////////////////////
              sql = "SELECT * FROM archives WHERE"; //
              // Hardcode field5 as a flexible search term --
              // arcade would prefer a general numeric field that is sortable
              // but Redsquare doesn't
              //
              if (obj.field5 || obj.hasOwnProperty('field5')) {
                if (obj.field5_sort) {
                  where_obj['field5'] = {
                    '>=': obj.field5
                  };
                  sql += ' archives.field5 >= $field5 AND';
                  params['$field5'] = obj.field5;
                  order_clause = ' ORDER BY archives.field5';
                  order_obj.by = 'field5';
                  delete obj.field5;
                  delete obj.field5_sort;
                }
              }
              for (key in obj) {
                if (this.schema.includes(key)) {
                  sql += " archives.".concat(key, " = $").concat(key, " AND");
                  params["$".concat(key)] = obj[key];
                  where_obj[key] = obj[key];
                }
              }
              sql = sql.substring(0, sql.length - 4);

              //
              // should we be ordering by timestamp instead of id?
              //
              sql += timestamp_limiting_clause + order_clause + " ".concat(sort, " LIMIT $limit");
              vault_access_read = !!(obj.access_script || obj.request_tx);
              if (vault_access_read) {
                console.log('--------------------------------\nARCHIVE LOAD TRANSACTIONS (VAULT ACCESS SELECT)\n--------------------------------\nSQL:\n' + sql + '\nparameters:\n' + JSON.stringify(archiveLogBindParams(params), null, 2) + '\n$owner:\n' + (params.$owner == null ? '(not bound)' : params.$owner) + '\n$sig:\n' + (params.$sig == null ? '(not bound)' : params.$sig) + '\n--------------------------------');
              }

              //
              // SEARCH BASED ON CRITERIA PROVIDED
              // Run SQL queries for full nodes, with JS-Store fallback for browsers
              //
              ts = Date.now();
              _context10.n = 1;
              return this.app.storage.queryDatabase(sql, params, 'archive');
            case 1:
              rows = _context10.v;
              if (!(this.app.BROWSER && !((_rows = rows) !== null && _rows !== void 0 && _rows.length))) {
                _context10.n = 3;
                break;
              }
              _context10.n = 2;
              return this.localDB.select({
                from: 'archives',
                where: where_obj,
                order: order_obj,
                limit: limit
              });
            case 2:
              rows = _context10.v;
              _context10.n = 4;
              break;
            case 3:
              fs = (_this$app3 = this.app) === null || _this$app3 === void 0 || (_this$app3 = _this$app3.storage) === null || _this$app3 === void 0 ? void 0 : _this$app3.returnFileSystem();
              if (!fs) {
                console.warn('!!!!!!!! NO FILESYSTEM !!!!!!!!!');
              } else {
                _iterator2 = _createForOfIteratorHelper(rows);
                try {
                  for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                    r = _step2.value;
                    if (!r.tx) {
                      filename = "".concat(__dirname, "/../../data/archive/").concat(r.sig);
                      if (fs.existsSync(filename)) {
                        r.tx = fs.readFileSync(filename, {
                          encoding: 'UTF-8'
                        });
                      }
                    }
                  }
                } catch (err) {
                  _iterator2.e(err);
                } finally {
                  _iterator2.f();
                }
              }
              time_elapsed = Date.now() - ts;
              if (time_elapsed > 0) {
                if (!(obj !== null && obj !== void 0 && obj.sig)) {
                  console.debug("==> Archive SQL query time: ".concat(time_elapsed, "ms -- "), sql, params, rows.length);
                }
              }
            case 4:
              if (vault_access_read) {
                row_summaries = (rows || []).map(function (r) {
                  return {
                    sig: r.sig,
                    owner: r.owner
                  };
                });
                console.log('--------------------------------\nARCHIVE LOAD TRANSACTIONS RESULT\n--------------------------------\nrows returned:\n' + (rows ? rows.length : 0) + '\nreturned row sig/owner:\n' + JSON.stringify(row_summaries, null, 2) + '\n--------------------------------');
              }

              //
              // before we return the content, we potential parse any content that
              // is protected by an access_hash that is not solved by an affixed
              // access_script
              //
              if (!(this.enforce_access_hash == 1)) {
                _context10.n = 12;
                break;
              }
              altered_rows = [];
              _iterator3 = _createForOfIteratorHelper(rows);
              _context10.p = 5;
              _loop = /*#__PURE__*/_regenerator().m(function _loop() {
                var r, access_script, access_witness, tx, txmsg, locking_script, computed_hash, hash_match, archive_ok;
                return _regenerator().w(function (_context1) {
                  while (1) switch (_context1.n) {
                    case 0:
                      r = _step3.value;
                      if (!r.owner) {
                        _context1.n = 4;
                        break;
                      }
                      access_script = obj.access_script || null;
                      access_witness = obj.access_witness || null; //let access_hash = obj.access_hash || null;
                      //
                      // if there is no script provided there is no witness data
                      // provided either, so we should "continue"
                      //
                      if (!access_script && access_witness) {
                        console.log('--------------------------------\nARCHIVE ACCESS WITNESS\n--------------------------------\n\n' + 'signature:\n' + r.sig + '\n\n' + 'owner:\n' + r.owner + '\n\n' + 'access_witness:\n' + JSON.stringify(function () {
                          try {
                            return typeof access_witness === 'string' ? JSON.parse(access_witness) : access_witness;
                          } catch (err) {
                            return access_witness;
                          }
                        }(), null, 2) + '\n\n--------------------------------');
                        try {
                          tx = new Transaction();
                          tx.deserialize_from_web(_this5.app, r.tx);
                          txmsg = tx.returnMessage();
                          if (txmsg.access_script) {
                            locking_script = txmsg.access_script;
                            try {
                              if (typeof locking_script === 'string') {
                                locking_script = JSON.parse(locking_script);
                              }
                            } catch (err) {
                              // leave as-is for logging
                            }
                            console.log('--------------------------------\nARCHIVE LOCKING SCRIPT\n--------------------------------\n\n' + JSON.stringify(locking_script, null, 2) + '\n\n--------------------------------');
                            access_script = _this5.app.core.scripting.mergeWitness(txmsg.access_script, obj.access_witness);
                            console.log('--------------------------------\nARCHIVE EXECUTABLE SCRIPT\n--------------------------------\n\n' + JSON.stringify(access_script, null, 2) + '\n\n--------------------------------');
                          }
                        } catch (err) {
                          console.log('Error processing access_witness in Archive...');
                        }
                      }
                      if (!access_script) {
                        _context1.n = 3;
                        break;
                      }
                      computed_hash = _this5.app.core.scripting.hash(access_script);
                      hash_match = computed_hash === r.owner;
                      console.log('--------------------------------\nARCHIVE OWNER CHECK\n\nstored owner:\n' + r.owner + '\n\ncomputed hash:\n' + computed_hash + '\n\nhash match:\n' + hash_match + '\n\n--------------------------------');
                      if (!(_this5.app.core.scripting.hash(access_script) === r.owner)) {
                        _context1.n = 2;
                        break;
                      }
                      _context1.n = 1;
                      return _this5.app.core.scripting.evaluateWithTransaction(access_script, request_tx);
                    case 1:
                      archive_ok = _context1.v;
                      console.log('--------------------------------\nARCHIVE SCRIPT RESULT\n\n' + (archive_ok ? 'true' : 'false') + '\n\n--------------------------------');
                      if (archive_ok) {
                        altered_rows.push(r);
                      } else {
                        console.log('--------------------------------\nARCHIVE REJECTED ROW\n\nsignature:\n' + r.sig + '\n\n--------------------------------');
                      }
                      _context1.n = 3;
                      break;
                    case 2:
                      console.log('--------------------------------\nARCHIVE REJECTED ROW\n\nsignature:\n' + r.sig + '\n\n--------------------------------');
                    case 3:
                      _context1.n = 5;
                      break;
                    case 4:
                      altered_rows.push(r);
                    case 5:
                      return _context1.a(2);
                  }
                }, _loop);
              });
              _iterator3.s();
            case 6:
              if ((_step3 = _iterator3.n()).done) {
                _context10.n = 8;
                break;
              }
              return _context10.d(_regeneratorValues(_loop()), 7);
            case 7:
              _context10.n = 6;
              break;
            case 8:
              _context10.n = 10;
              break;
            case 9:
              _context10.p = 9;
              _t3 = _context10.v;
              _iterator3.e(_t3);
            case 10:
              _context10.p = 10;
              _iterator3.f();
              return _context10.f(10);
            case 11:
              rows = altered_rows;
            case 12:
              return _context10.a(2, rows);
          }
        }, _callee1, this, [[5, 9, 10, 11]]);
      }));
      function loadTransactions() {
        return _loadTransactions.apply(this, arguments);
      }
      return loadTransactions;
    }() ////////////
    // delete //
    ////////////
    //
    // Our Requests:
    //
    // - users can delete any transactions they OWN
    // - server operator can delete any transactions anytime
    // - server operator respectfully avoid deleting transactions with preserve=1
    //
  }, {
    key: "deleteTransaction",
    value: function () {
      var _deleteTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee10(tx) {
        var obj,
          sql,
          params,
          rows,
          timestamp_limiting_clause,
          where_obj,
          sig,
          select_sql,
          select_params,
          existing_rows,
          existing_row,
          can_delete,
          request_tx,
          fs,
          path,
          filepath,
          _args11 = arguments;
        return _regenerator().w(function (_context11) {
          while (1) switch (_context11.n) {
            case 0:
              obj = _args11.length > 1 && _args11[1] !== undefined ? _args11[1] : {};
              sql = '';
              params = {};
              rows = [];
              timestamp_limiting_clause = '';
              where_obj = {};
              if (!(tx !== null && tx !== void 0 && tx.signature)) {
                _context11.n = 1;
                break;
              }
              sig = tx.signature;
              _context11.n = 3;
              break;
            case 1:
              if (!(typeof tx === 'string')) {
                _context11.n = 2;
                break;
              }
              sig = tx;
              _context11.n = 3;
              break;
            case 2:
              console.error('Not a valid tx/signature');
              return _context11.a(2, false);
            case 3:
              //
              // FIRST: SELECT the transaction to check its owner field
              //
              select_sql = "SELECT sig, owner FROM archives WHERE archives.sig = $sig";
              select_params = {
                $sig: sig
              };
              _context11.n = 4;
              return this.app.storage.queryDatabase(select_sql, select_params, 'archive');
            case 4:
              existing_rows = _context11.v;
              if (!(this.app.BROWSER && (!existing_rows || existing_rows.length === 0))) {
                _context11.n = 6;
                break;
              }
              _context11.n = 5;
              return this.localDB.select({
                from: 'archives',
                where: {
                  sig: sig
                },
                limit: 1
              });
            case 5:
              existing_rows = _context11.v;
            case 6:
              if (!(!existing_rows || existing_rows.length === 0)) {
                _context11.n = 7;
                break;
              }
              return _context11.a(2, false);
            case 7:
              existing_row = existing_rows[0]; //
              // SECOND: Check if owner is specified and verify ownership
              //
              if (!(existing_row.owner && existing_row.owner !== '')) {
                _context11.n = 15;
                break;
              }
              //
              // Owner is specified, need to verify access
              //
              console.log('*****************');
              console.log('DELETE ACCESS HASH CHECK');
              console.log('*****************');

              // Check if access credentials are provided
              if (obj.access_script) {
                _context11.n = 8;
                break;
              }
              console.log('DELETE DENIED: No access_script or access_witness provided');
              return _context11.a(2, false);
            case 8:
              can_delete = false;
              request_tx = obj.request_tx || tx || null;
              if (!(this.app.core.scripting.hash(obj.access_script) === existing_row.owner)) {
                _context11.n = 12;
                break;
              }
              _context11.n = 9;
              return this.app.core.scripting.evaluateWithTransaction(obj.access_script, request_tx);
            case 9:
              if (!_context11.v) {
                _context11.n = 10;
                break;
              }
              can_delete = true;
              console.log('DELETE ACCESS GRANTED: Script evaluation passed');
              _context11.n = 11;
              break;
            case 10:
              console.log('DELETE DENIED: Script evaluation failed');
            case 11:
              _context11.n = 13;
              break;
            case 12:
              console.log('DELETE DENIED: access_hash does not match supplied script');
            case 13:
              if (can_delete) {
                _context11.n = 14;
                break;
              }
              return _context11.a(2, false);
            case 14:
              _context11.n = 16;
              break;
            case 15:
              //
              // No owner specified, proceed with deletion (existing behavior)
              //
              console.log('No owner specified for transaction, proceeding with deletion');
            case 16:
              //
              // THIRD: Proceed with deletion if ownership verified or no owner
              //
              sql = "DELETE FROM archives WHERE archives.sig = $sig";
              params = {
                $sig: sig
              };
              _context11.n = 17;
              return this.app.storage.runDatabase(sql, params, 'archive');
            case 17:
              //
              // browsers handle with localDB search
              //
              where_obj['sig'] = sig;
              if (!this.app.BROWSER) {
                _context11.n = 19;
                break;
              }
              _context11.n = 18;
              return this.localDB.remove({
                from: 'archives',
                where: where_obj
              });
            case 18:
              rows = _context11.v;
              if (rows) {
                console.log('DELETED FROM localDB! ');
              } else {
                console.log('Record not found in localDB to delete');
              }
              _context11.n = 20;
              break;
            case 19:
              fs = this.app.storage.returnFileSystem();
              path = this.app.storage.returnPath();
              if (fs && path) {
                filepath = path.normalize("".concat(__dirname, "/../../data/archive/").concat(sig));
                if (fs.existsSync(filepath)) {
                  fs.unlink(filepath, function (err) {
                    if (err) {
                      console.error(err);
                    } else {
                      console.info("Deleted ".concat(filepath));
                    }
                  });
                }
              }
            case 20:
              return _context11.a(2, true);
          }
        }, _callee10, this);
      }));
      function deleteTransaction(_x9) {
        return _deleteTransaction.apply(this, arguments);
      }
      return deleteTransaction;
    }() ////////////
    // delete //
    ////////////
    //
    // Our Rules:
    //
    // - users can delete any transactions they OWN
    // - server operator can delete any transactions anytime
    // - server operator respectfully avoid deleting transactions with preserve=1
    //
  }, {
    key: "deleteTransactions",
    value: function () {
      var _deleteTransactions = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee11() {
        var obj,
          rows,
          timestamp_limiting_clause,
          where_obj1,
          sql,
          sql_substring,
          params,
          where_obj2,
          param_ct,
          key,
          where_obj,
          _args12 = arguments;
        return _regenerator().w(function (_context12) {
          while (1) switch (_context12.n) {
            case 0:
              obj = _args12.length > 0 && _args12[0] !== undefined ? _args12[0] : {};
              rows = [];
              timestamp_limiting_clause = ' archives.preserve = 0';
              where_obj1 = {};
              if (obj.created_later_than) {
                timestamp_limiting_clause += ' AND archives.created_at > ' + parseInt(obj.created_later_than);
                where_obj1 = {
                  created_at: {
                    '>': parseInt(obj.created_later_than)
                  }
                };
              }
              if (obj.created_earlier_than) {
                timestamp_limiting_clause += ' AND archives.created_at < ' + parseInt(obj.created_earlier_than);
                where_obj1 = {
                  created_at: {
                    '<': parseInt(obj.created_earlier_than)
                  }
                };
              }
              if (obj.updated_later_than) {
                timestamp_limiting_clause += ' AND archives.updated_at > ' + parseInt(obj.updated_later_than);
                where_obj1 = {
                  updated_at: {
                    '>': parseInt(obj.updated_later_than)
                  }
                };
              }
              if (obj.updated_earlier_than) {
                timestamp_limiting_clause += ' AND archives.updated_at < ' + parseInt(obj.updated_earlier_than);
                where_obj1 = {
                  updated_at: {
                    '<': parseInt(obj.updated_earlier_than)
                  }
                };
              }
              where_obj1['preserve'] = 0;

              //
              // SEARCH BASED ON CRITERIA PROVIDED
              //
              sql = "DELETE FROM archives WHERE ";
              sql_substring = '';
              params = {};
              where_obj2 = {};
              param_ct = 0;
              for (key in obj) {
                if (this.schema.includes(key)) {
                  sql_substring += "archives.".concat(key, " = $").concat(key, " OR ");
                  params["$".concat(key)] = obj[key];
                  if (param_ct++ > 0) {
                    if (where_obj2['or']) {
                      where_obj2.or[key] = obj[key];
                    } else {
                      where_obj2['or'] = {};
                      where_obj2.or[key] = obj[key];
                    }
                  } else {
                    where_obj2[key] = obj[key];
                  }
                }
              }
              sql_substring = sql_substring.substring(0, sql_substring.length - 4);
              if (param_ct > 1) {
                sql += "(".concat(sql_substring, ")");
              } else {
                sql += sql_substring;
              }
              if (param_ct > 1) {
                where_obj = [where_obj1, where_obj2];
                sql += ' AND' + timestamp_limiting_clause;
              } else if (param_ct == 1) {
                where_obj = Object.assign(where_obj1, where_obj2);
              } else {
                where_obj = where_obj1;
                sql += timestamp_limiting_clause;
              }
              _context12.n = 1;
              return this.app.storage.runDatabase(sql, params, 'archive');
            case 1:
              rows = _context12.v;
              if (!this.app.BROWSER) {
                _context12.n = 3;
                break;
              }
              _context12.n = 2;
              return this.localDB.remove({
                from: 'archives',
                where: where_obj
              });
            case 2:
              rows = _context12.v;
            case 3:
              return _context12.a(2);
          }
        }, _callee11, this);
      }));
      function deleteTransactions() {
        return _deleteTransactions.apply(this, arguments);
      }
      return deleteTransactions;
    }() //
    // Pruning
    //
    // the Archive module stores two types of transactions:
    //
    // - blockchain transactions (no owner)
    // - saved user transactions (owner)
    //
    // we want to keep a copy of all blockchain transactions for about a month and then
    // prune them automatically since they can be restored by parsing the chain as needed
    // but should not be needed.
    //
    // users will submit requests to save-and-update copies of the transactions that affect
    // them, and this has the potential to place a greater load on the server. for this
    // reason, we have a harder limit for these transactions, and will delete them after
    // 2,000 transactions or once they are older than 3 weeks.
    //
    // modules that save data can decide which transactions to keep and which ones to
    // delete based on internal transaction logic. we will respectfully avoid deleting any
    // transactions that users have marked as prune = false, although this may change in
    // the future if it is abused.
    //
  }, {
    key: "pruneArchive",
    value: function () {
      var _pruneArchive = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee12() {
        var now, ts, removed, _results, _results3, _results5, _results7, pruned_ct, sql, params, results, _results2, _results4, _results6, _results8, rows, _iterator4, _step4, r, _t4;
        return _regenerator().w(function (_context13) {
          while (1) switch (_context13.p = _context13.n) {
            case 0:
              console.log('$');
              console.log('$');
              console.log('$ PURGING ARCHIVE');
              console.log('$');
              console.log('$');

              // SQL
              now = new Date().getTime();
              ts = now - this.prune_public_ts; //
              // Browsers drop preserve=0 rows older than prune_public_ts.
              //
              if (!this.app.BROWSER) {
                _context13.n = 2;
                break;
              }
              _context13.n = 1;
              return this.localDB.remove({
                from: 'archives',
                where: {
                  preserve: 0,
                  updated_at: {
                    '<': ts
                  }
                }
              });
            case 1:
              removed = _context13.v;
              console.log(removed, 'automatically pruned from local archive');
              _context13.n = 14;
              break;
            case 2:
              //
              // Servers clean up SQL / file storage
              //
              pruned_ct = 0; //
              // delete flagged transactions
              //
              sql = "DELETE FROM archives WHERE flagged = 1 AND tx != ''";
              params = {};
              _context13.n = 3;
              return this.app.storage.runDatabase(sql, params, 'archive');
            case 3:
              results = _context13.v;
              if ((_results = results) !== null && _results !== void 0 && _results.changes) {
                pruned_ct += (_results2 = results) === null || _results2 === void 0 ? void 0 : _results2.changes;
              }

              //
              // delete public blockchain transactions
              //
              sql = "DELETE FROM archives WHERE owner = \"\" AND updated_at < $ts AND preserve = 0 AND tx != ''";
              params = {
                $ts: now - this.prune_public_ts
              };
              _context13.n = 4;
              return this.app.storage.runDatabase(sql, params, 'archive');
            case 4:
              results = _context13.v;
              if ((_results3 = results) !== null && _results3 !== void 0 && _results3.changes) {
                pruned_ct += (_results4 = results) === null || _results4 === void 0 ? void 0 : _results4.changes;
              }

              //
              // delete private transactions
              //
              sql = "DELETE FROM archives WHERE owner != \"\" AND updated_at < $ts AND preserve = 0 AND tx != ''";
              params = {
                $ts: now - this.prune_private_ts
              };
              _context13.n = 5;
              return this.app.storage.runDatabase(sql, params, 'archive');
            case 5:
              results = _context13.v;
              if ((_results5 = results) !== null && _results5 !== void 0 && _results5.changes) {
                pruned_ct += (_results6 = results) === null || _results6 === void 0 ? void 0 : _results6.changes;
              }

              //
              // delete invalid antiquated transactions 1 year ago
              //
              sql = "DELETE FROM archives WHERE ( tx_size = 0 or field1 = 'RedSquare') and updated_at < $ts";
              params = {
                $ts: now - 50 * this.prune_public_ts
              };
              _context13.n = 6;
              return this.app.storage.runDatabase(sql, params, 'archive');
            case 6:
              results = _context13.v;
              if ((_results7 = results) !== null && _results7 !== void 0 && _results7.changes) {
                pruned_ct += (_results8 = results) === null || _results8 === void 0 ? void 0 : _results8.changes;
              }
              console.log("Deleted ".concat(pruned_ct, " txs from archive"));

              //
              // Need to add something to delete the super big transactions as well...
              //
              params = {
                $ts: now - this.prune_public_ts
              };
              sql = "SELECT sig FROM archives WHERE updated_at < $ts AND (preserve = 0 OR flagged = 1) AND tx = ''";
              _context13.n = 7;
              return this.app.storage.queryDatabase(sql, params, 'archive');
            case 7:
              rows = _context13.v;
              _iterator4 = _createForOfIteratorHelper(rows);
              _context13.p = 8;
              _iterator4.s();
            case 9:
              if ((_step4 = _iterator4.n()).done) {
                _context13.n = 11;
                break;
              }
              r = _step4.value;
              _context13.n = 10;
              return this.deleteTransaction(r.sig);
            case 10:
              _context13.n = 9;
              break;
            case 11:
              _context13.n = 13;
              break;
            case 12:
              _context13.p = 12;
              _t4 = _context13.v;
              _iterator4.e(_t4);
            case 13:
              _context13.p = 13;
              _iterator4.f();
              return _context13.f(13);
            case 14:
              this.archive.last_prune = now;
              this.save();
            case 15:
              return _context13.a(2);
          }
        }, _callee12, this, [[8, 12, 13, 14]]);
      }));
      function pruneArchive() {
        return _pruneArchive.apply(this, arguments);
      }
      return pruneArchive;
    }() //////////////////////////
    // listen to everything //
    //////////////////////////
  }, {
    key: "shouldAffixCallbackToModule",
    value: function shouldAffixCallbackToModule(modname) {
      if (this.opt_out.includes(modname)) {
        return 0;
      }
      return 1;
    }

    ///////////////
    // save/load //
    ///////////////
  }, {
    key: "hasSettings",
    value: function hasSettings() {
      return true;
    }
  }, {
    key: "loadSettings",
    value: function loadSettings() {
      var container = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '.saito-module-settings';
      var settings = new ArchiveSettings(this.app, this, container);
      settings.render();
    }
  }, {
    key: "returnPrunePublicDays",
    value: function returnPrunePublicDays() {
      var days = Math.round(this.prune_public_ts / (24 * 60 * 60 * 1000));
      return days > 0 ? days : 1;
    }
  }, {
    key: "setPrunePublicDays",
    value: function setPrunePublicDays(days) {
      var ms = days * 24 * 60 * 60 * 1000;
      this.prune_public_ts = ms;
      this.archive.prune_public_ts = ms;
      this.save();
    }
  }, {
    key: "load",
    value: function load() {
      if (this.app.options.archive) {
        this.archive = this.app.options.archive;
        if (Number.isFinite(this.archive.prune_public_ts) && this.archive.prune_public_ts > 0) {
          this.prune_public_ts = this.archive.prune_public_ts;
        }
      } else {
        this.archive = {};
        this.archive.index_blockchain = 0;
        if (this.app.BROWSER == 0) {
          this.archive.index_blockchain = 1;
        }
        this.save();
      }
    }
  }, {
    key: "save",
    value: function save() {
      this.archive.wallet_version = this.app.options.wallet.version;
      this.app.options.archive = this.archive;
      this.app.storage.saveOptions();
    }
  }, {
    key: "onUpgrade",
    value: function () {
      var _onUpgrade = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee13(type, privatekey, walletfile) {
        var _t5, _t6;
        return _regenerator().w(function (_context14) {
          while (1) switch (_context14.p = _context14.n) {
            case 0:
              if (!(type == 'nuke' && this.localDB)) {
                _context14.n = 7;
                break;
              }
              _context14.p = 1;
              _context14.n = 2;
              return this.localDB.dropDb();
            case 2:
              _context14.n = 4;
              break;
            case 3:
              _context14.p = 3;
              _t5 = _context14.v;
            case 4:
              _context14.p = 4;
              _context14.n = 5;
              return this.initInBrowserDatabase();
            case 5:
              _context14.n = 7;
              break;
            case 6:
              _context14.p = 6;
              _t6 = _context14.v;
            case 7:
              return _context14.a(2, 1);
          }
        }, _callee13, this, [[4, 6], [1, 3]]);
      }));
      function onUpgrade(_x0, _x1, _x10) {
        return _onUpgrade.apply(this, arguments);
      }
      return onUpgrade;
    }()
  }]);
}(ModTemplate);
module.exports = Archive;